<template>
<div class="chapter">
<div class="inner_page">
<div class="addText1">
<div class="illustration2">
<img alt="" src="images/dedication_LIO_2012.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration3">
<img alt="" src="images/0627stagger.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0628_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0629lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0630lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0701lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0702lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0703lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0704lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0705_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0706lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0707lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0708lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0709lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0710lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0711lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0712_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0713lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0714lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0715lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0716lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0717lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0718lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0719_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0720lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0721lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0722lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0723lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0724lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0725lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration2">
<img alt="" src="images/0726_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0727lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0728lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0729lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0730lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0731lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0801lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0802_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0803lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0804lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0805lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0806lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0807lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0808lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0809_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0810lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0811lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0812lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0813lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0814lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0815lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0816_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0817lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0818lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0819lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0820lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0821lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0822lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0823_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0824lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0825lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0826lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0827lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0828lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0829lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0830_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0831lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0901lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0902lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0903lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0904lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0905lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0906_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0907lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0908lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0909lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0910lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0911lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0912lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration2">
<img alt="" src="images/0913_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0914lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0915lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0916lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0917lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0918lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0919lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0920_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0921lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0922lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0923lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0924lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0925lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0926lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/0927_comb_tslio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/0928lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/0929lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/0930lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration">
<img alt="" class="bottom" src="images/1001lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" class="bottom" src="images/1002lio09.jpg"/>
</div>
<div class="illustration">
<img alt="" src="images/1003lio09.jpg"/>
</div>
</div>
<div class="addText1">
<div class="illustration4">
<img alt="" src="images/1004_comb_tslio09.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a2.vue?7757d19e